import styled, { css } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { ButtonTheme, ButtonV2 } from 'builder/components/Button'

type ButtonContainerRightProps = {
  $isInvisible?: boolean
  $invisibilityStrategy?: 'invisible' | 'none'
}

export const Topbar = styled.div<{ previewWidth?: number }>`
  position: absolute;
  left: 0px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: -60px;
  ${({ previewWidth }) =>
    typeof previewWidth === 'number' &&
    previewWidth < 450 &&
    css`
      left: 50%;
      margin-left: -225px;
      width: 450px;
    `};
`

export const ButtonContainerRight = styled.div<ButtonContainerRightProps>(props => {
  const { $isInvisible, $invisibilityStrategy } = props
  return css`
    display: flex;
    flex-direction: row;
    align-items: center;

    ${$isInvisible &&
    ($invisibilityStrategy === 'invisible'
      ? css`
          visibility: hidden;
          opacity: 0;
          pointer-events: none;
        `
      : css`
          display: none;
        `)}
  `
})

export const SelectTemplateButtonContainer = styled.div`
  position: relative;
`

export const SelectTemplateButton = styled(ButtonV2).attrs({ theme: ButtonTheme.secondary })`
  background-color: ${Colors.Blue20};

  &:hover {
    background-color: ${Colors.Blue30};
  }
`
